const config = {
  headers: {
    Authorization: `Bearer "${localStorage.getItem("token")}"`,
  },
};
const config2 = {
  headers: {
    Authorization: `Bearer "${localStorage.getItem("token")}"`,
    "Content-Type": "application/json",
  },
};

module.exports = {
  token: localStorage.getItem("token"),
  base_url: "https://hmobw.mgmhealthcare.in/api/admin",
  // base_url: "http://localhost:5000/api/admin",
  // base_url: "https://ampathapi.prodmirror.com/api/admin",
  // base_url: "https://api.healthmo.ai/api/admin",
  appointment_base_url: "https://hmobw.mgmhealthcare.in/api",
  headers: { Accept: "*/*", "Content-type": "application/json; charset=UTF-8" },
  landing_api_url: "https://hmobw.mgmhealthcare.in/api/",
  // landing_api_url: "https://mbk.mgmhealthcare.in/api",
  landing_api_key: "3d32444a96d5a1516ab7b916f39ac793ed14735f7da6ab9a709c94d19a6d4062291615ce6cd83155b6267d0637e020838cda46e6a88456a312f7e5d611ca3a2f",
  user_auth: "",
  config,
  config2,
};
